const AUTH_TOKEN_KEY = 'auth_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

export class SessionStorageHelper {
    private static _instance: SessionStorageHelper;

    private constructor() {}

    public static getInstance(): SessionStorageHelper {
        if (!this._instance) {
            this._instance = new SessionStorageHelper();
        }
        return this._instance;
    }

    private isAvailable(): boolean {
        try {
            const test = '__sessionStorage_test__';
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch {
            return false;
        }
    }

    getItem(key: string): string | null {
        if (!this.isAvailable()) return null;
        try {
            return sessionStorage.getItem(key);
        } catch {
            return null;
        }
    }

    setItem(key: string, value: string): void {
        if (!this.isAvailable()) return;
        try {
            sessionStorage.setItem(key, value);
        } catch {
            console.error('Error setting item in sessionStorage');
        }
    }

    removeItem(key: string): void {
        if (!this.isAvailable()) return;
        try {
            sessionStorage.removeItem(key);
        } catch {
            console.error('Error removing item from sessionStorage');
        }
    }

    static getToken(): string | null {
        return SessionStorageHelper.getInstance().getItem(AUTH_TOKEN_KEY);
    }

    static setToken(token: string): void {
        SessionStorageHelper.getInstance().setItem(AUTH_TOKEN_KEY, token);
    }

    static clearToken(): void {
        SessionStorageHelper.getInstance().removeItem(AUTH_TOKEN_KEY);
    }

    static getRefreshToken(): string | null {
        return SessionStorageHelper.getInstance().getItem(REFRESH_TOKEN_KEY);
    }

    static setRefreshToken(token: string): void {
        SessionStorageHelper.getInstance().setItem(REFRESH_TOKEN_KEY, token);
    }

    static clearRefreshToken(): void {
        SessionStorageHelper.getInstance().removeItem(REFRESH_TOKEN_KEY);
    }

    /**
     * Clears both the access JWT and the refresh token. Call on logout and on
     * any unrecoverable auth failure before redirecting to /signin.
     */
    static clearAll(): void {
        SessionStorageHelper.clearToken();
        SessionStorageHelper.clearRefreshToken();
    }
}
